import OrderStore from '../stores/order-store'
import ImageStore from '../stores/image-store'
import UploadStore from '../stores/upload-store'
import ProductStore from '../stores/product-store'
import ProductCalculations from '../utils/product-calculations'
import OpeImagePhotoorganiser from '../objects/opeimage/photoorganiser'
import Config from '../config'


function EditorOutputCreator () {
}

/**
 * Generate an object that represents all the selections a user has done in the editor. This
 * includes images, quantities, product, cropping, zooming, image effects and upsales etc.
 *
 * This object can be converted to JSON and sent as an order or stored for later retreval
 * @return {Object}
 */
EditorOutputCreator.prototype.create = function () {
	//Sort items first
	OrderStore.sortItemsByImageTakenDate();

	//Get the items from the orderStore
	var orderItemList = OrderStore.getItems();

	//Validate
	if (orderItemList == null) {
		throw new Error("Cannot create output json because the orderItemList from orderStore.getItems() is null");
	}
	if (orderItemList.length == 0) {
		throw new Error("Cannot create output json because the orderItemList from orderStore.getItems() is a list with zero items in it");
	}

	var result = {};

	var editorId = "#{Octopus.Release.Number}";
	var editorTypeId = 'Prints Editor';

	if (sessionStorage.getItem("editorId") != "" && sessionStorage.getItem("editorId") != undefined && sessionStorage.getItem("editorId") != "undefined") {
		editorId = sessionStorage.getItem("editorId");
	}
	if (sessionStorage.getItem("editorTypeId") != "" && sessionStorage.getItem("editorTypeId") != undefined && sessionStorage.getItem("editorTypeId") != "undefined") {
		editorTypeId = sessionStorage.getItem("editorTypeId");
	}

	result.channel = sessionStorage.getItem("channel");
	result.computerName = 'xxx';
	result.editorId = editorId;
	result.editorTypeId = editorTypeId;
	result.product = {};
	result.product.productTitle = _("Prints");
	result.product.images = [];

	for (var i = 0; i < orderItemList.length; i++) {
		var image = {};
		var opeImage = ImageStore.getImageById(orderItemList[i].getImageId());
		var options = orderItemList[i].getOptions();
		var product = ProductStore.getProductById(orderItemList[i].getProductId());
		var productHasBeenUpgraded = false;

		//Check if this product has an upgrade product upsell enabled and replace the product if it has
		for (var name in options) {
			if (options[name] === true && name.indexOf("upgradeProduct_") > -1) {
				var upgradeProduct = ProductStore.getProductById(ProductCalculations.getUpsellProductId(product.getId()));
				productHasBeenUpgraded = true;
			}
		}

		//Check if it's a polaroid product
		var polaroid = false;
		var productCustomSettings = null;
		if (product.options.customSettings) {
			for (var key in product.options.customSettings) {
				if (product.options.customSettings.hasOwnProperty(key)) {
					if (product.options.customSettings[key].polaroid) {
						polaroid = true;
						productCustomSettings = product.options.customSettings[key];
					}
				}
			}

		}

		image.product = product.getId();
		if (productHasBeenUpgraded) {
			image.product = upgradeProduct.getId();
		}
		//It's a polaroid virtual product, needs to be merged back into it's original product
		if (image.product.indexOf('_polaroid') > -1) {
			image.product = image.product.substr(0, image.product.indexOf('_polaroid'));
		}
		image.quantity = orderItemList[i].getQuantity();
		image.imageId = opeImage.getSourceId();
		image.dateTaken = orderItemList[i].getImageTakenDate();
		image.isPortrait = orderItemList[i].isPortrait;
		image.loadData = btoa(unescape(encodeURIComponent(JSON.stringify({
			imageHeight: opeImage.getHeight(),
			imageWidth: opeImage.getWidth(),
			productWidth: orderItemList[i].getProductWidth(),
			productHeight: orderItemList[i].getProductHeight(),
			itemOptions: orderItemList[i].options,
			isPortrait: orderItemList[i].isPortrait,
			virtualPolaroidProduct: (product.getId().indexOf('_polaroid') > -1 ? product.getId() : '')
		}))));

		image.imageSource = 'ORGANISE';
		image.imageSourceProperty = {
			type: "ORGANISE"
		};

		if (opeImage instanceof OpeImagePhotoorganiser) {
			image.imageSourceProperty.userId = sessionStorage.getItem("photoOrganiseUserId");
		}

		if (polaroid) {
			image.postProcess = [
									{
										text: orderItemList[i].options.polaroidText,
										type: "polaroid"
									}

								];
		} else {
			image.postProcess = [];
		}
		image.options = [];

		//Add upsale options
		for (var name in options) {
			//Only include options that are enabled and not an upgradeproduct
			if (options[name] === true && name.indexOf("upgradeProduct_") == -1) {
				if (productHasBeenUpgraded) {
					image.options.push({vendorArticleOptionID: upgradeProduct.getOptionVendorArticleOptionIdByName(name)});
				} else {
					image.options.push({vendorArticleOptionID: product.getOptionVendorArticleOptionIdByName(name)});
				}

			}
		}

		//Add paper length option
		if (productHasBeenUpgraded) {
			var productHeight = upgradeProduct.getHeight();
			var productWidth = ProductCalculations.getProductWidthByAspect(upgradeProduct, orderItemList[i].getProductWidth()/orderItemList[i].getProductHeight());
			image.options.push({vendorArticleOptionID: upgradeProduct.getWidthVendorArticleOptionIdByWidth(productWidth)});
		} else if (polaroid) {
			var productWidth = productCustomSettings.canvasWidth;
			var productHeight = productCustomSettings.canvasHeight;
			image.options.push({vendorArticleOptionID: product.getWidthVendorArticleOptionIdByWidth(orderItemList[i].getProductWidth())});
		} else {
			var productHeight = orderItemList[i].getProductHeight()
			var productWidth = orderItemList[i].getProductWidth();
			image.options.push({vendorArticleOptionID: product.getWidthVendorArticleOptionIdByWidth(orderItemList[i].getProductWidth())});
		}

		//Set filter on the image
		image.filter = this._getImageFilter(orderItemList[i], opeImage, image.product,productHeight, productWidth, options['border'] === true, options['imageEnhancement'] === true);

		result.product.images.push(image);
	}

	return result;
};

/**
 * When the image is scaled, panned and cropped, the values are not stored within the
 * imageFilter of the image. But when it's time to create the order, these values should be
 * applied to the imageFilter so that the server that process the order can just download
 * ready cropped, rotated and filtered images from the edit server. This function puts
 * cropping into the imageFilter and returns the new image filter
 * @param  {OpeOrderItem}
 * @param  {OpeImage}
 * @return {Object}
 */
EditorOutputCreator.prototype._getImageFilter = function (item, image, productId, productHeight, productWidth, hasBorder, hasImageEnhancement) {
	var filters = JSON.parse(JSON.stringify(item.getImageFilters()));
	var positionData = item.getImagePositionData();
	var height = image.getHeight();
	var width = image.getWidth();
	var scale = item.getImageScale();
	var product = ProductStore.getProductById(productId);
	var productRatio = parseFloat(productWidth) / productHeight;

    //Handle the case where the uploader failed to read the exif from the image
    //Get the rotation data from the server and apply it to the image in the order
    var uploadStoreData = UploadStore.getData();
    if (uploadStoreData.uploadWarnings.hasOwnProperty(image.getId())) {
        uploadStoreData.uploadWarnings[image.getId()].forEach (function (warning) {
            if (warning.code === 'READ_EXIF_FAILED') {
                var serverData = image.getServerData();
                var rotation = 0;
                if (!serverData) {
                    // @TODO: Fix the root cause of the issue.
                    logToCentralServer("No server data in EditorOutputCreator._getImageFilter() rotationAngle",
                        "", 3);
                }
                else {
                    rotation = serverData.rotationAngle;
                }

                if (rotation === 90 || rotation === 270) {
                    if (!filters.hasOwnProperty("rotate")) {
                        filters.rotate = {angle: 0, flip: 'NONE'};
                    }
                    filters.rotate.angle += 90;
                    if (filters.rotate.angle === 360) {
                        filters.rotate.angle = 0;
                    }
                }
            }
        });
    }

	//Calculate x and y in %
	var x = 0;
	var y = 0;
	if (positionData.hasOwnProperty("percentageX") && positionData.hasOwnProperty("percentageY")) {
		x = (positionData.percentageX/scale)*-100;
		y = (positionData.percentageY/scale)*-100;
	}

	var h;
	var w;
	// looks like IE is failing. replaced with simple check instead
	// https://stackoverflow.com/questions/34857955/hasownpropertygetcomputedstyle-false-in-ie-11
	if (item.options.crop) {
		//The image has been edited by the user, and we can get the crop values from the item
		//Calculate h and w in %
		h = item.options.crop.h/scale;
		w = item.options.crop.w/scale;
	} else { //The image has not been edited by the user, but might still be rotated, flipped and cropped automatically
		var cropSize = this._calculateImageCropSize(item, height, width, productRatio, filters, scale);
		h = cropSize.h;
		w = cropSize.w;
	}

	//Make sure that x,y,h and w is numbers and not something else
	x = parseFloat(x);
	y = parseFloat(y);
	h = parseFloat(h);
	w = parseFloat(w);

	//Check that x,y,h and w is between 0 and 100, and if not, set them to 0 or 100
	if (!(x >= 0 && x <= 100)) {
		x = 0;
	}
	if (!(y >= 0 && y <= 100)) {
		y = 0;
	}
	if (!(h >= 0 && h <= 100)) {
		h = 100;
	}
	if (!(w >= 0 && w <= 100)) {
		w = 100;
	}

	//Sometimes the values are just a bit above 100 when added beacuse of inaccuracies when cropping, so then we shorten them a bit so that they become less
	if (x+w > 100) {
		w = 100-x;
	}
	if (h+y > 100) {
		h = 100-y;
	}

	//Create the crop filter, but only if crop is needed
	if (x != 0 || y != 0 || h != 100 || w != 100) {
		filters.crop = {
			x: x,
			y: y,
			w: w,
			h: h,
		};

		if (filters.crop.w > 100 || filters.crop.h > 100) {
			if (console) {
				console.log("image", image);
				console.log("filters", filters);
				console.log("item", item);
			}
			throw new OpeException("Something went wrong with the filter calulations, calulated above 100% on crop.", {filters: JSON.stringify(filters)});
		}
		if ((filters.crop.x+filters.crop.w) > 100 || (filters.crop.y+filters.crop.h) > 100) {
			if (console) {
				console.log("image", image);
				console.log("filters", filters);
				console.log("item", item);
			}
			throw new OpeException("Something went wrong with the filter calulations, x+w or y+h is larger than 100%.", {filters: JSON.stringify(filters)});
		}
	}


	//Add production specific data (should not be done in the editor, but temporary solution)
	var dpi = Config.ManufacturingData.products[item.getProductId()].dpi;

	filters.prep = {};
	if (item.isPortrait) {
		filters.prep.h = Math.round((productWidth*dpi)/2.54);
		filters.prep.w = Math.round((productHeight*dpi)/2.54);
	} else {
		filters.prep.h = Math.round((productHeight*dpi)/2.54);
		filters.prep.w = Math.round((productWidth*dpi)/2.54);
	}

	if (hasBorder) {
		var border = Config.ManufacturingData.products[item.getProductId()].borderWidth;
		filters.prep.imageBorder = {};
		filters.prep.imageBorder.shouldApply = true;
		filters.prep.imageBorder.w = Math.round(((border/10)*dpi)/2.54);
		filters.prep.imageBorder.color = 'White';
	}

	if (hasImageEnhancement) {
		if (!filters.hasOwnProperty("effects")) {
			filters.effects = [];
		}
		filters.effects.push({type: "Enhance"});
	}

	if (filters.hasOwnProperty("rotate")) {
		var angle = filters.rotate.angle;
		if (angle == undefined || angle == "undefined" || angle == null) {
			angle = 0;
		}

		filters.rotate.angle = angle;
		filters.rotate.flip = "NONE";
	}

	return filters;
};

EditorOutputCreator.prototype._calculateImageCropSize = function (item, height, width, productRatio, filters, scale) {

	if (height >= width) {
		var imageRatio = height/width;
	} else {
		var imageRatio = width/height;
	}

	if (imageRatio >= productRatio) {
		var diff = imageRatio - productRatio;
	} else {
		var diff = productRatio - imageRatio;
	}

	//Does it have rotation?
	var rotation;
	// TODO: check why we have too many try catches in places we don't need
	try {
		rotation = filters.rotate.angle;
	} catch (e) {
		rotation = 0;
	}

	//Flip height and width if the image is rotated
	if (rotation == 90 || rotation == 270 || rotation == -90 || rotation == -270) {
		var temp = height;
		height = width;
		width = temp;
	}

	var newWidth;
	var newHeight;
	if (diff <= Config.ProductRatioWarning) {
		newWidth = width;
		newHeight = height;
	} else {
		if (productRatio == 1) {
			//Square image
			newWidth = (width <= height ? width: height);
			newHeight = (width <= height ? width: height);
		} else if (productRatio < imageRatio && item.isPortrait) {
			//Portrait image, smaller ratio, cut height to make it fit the product
			newWidth = width;
			newHeight = width * productRatio;
		} else if (productRatio < imageRatio && !item.isPortrait) {
			//Landscape image, smaller ratio, cut width to make it fit the product
			newWidth = height * productRatio;
			newHeight = height;
		} else if (productRatio > imageRatio && item.isPortrait) {
			//Portrait image, larger ratio, cut width to make it fit the product
			newWidth = height / productRatio;
			newHeight = height;
		} else if (productRatio > imageRatio && !item.isPortrait) {
			//Landscape image, larger ratio, cut height to make it fit the product
			newWidth = width;
			newHeight = width / productRatio;
		}
	}

	//Scale the sizes
	newWidth = newWidth/scale;
	newHeight = newHeight/scale;

	//Calculate percentages
	var w = (newWidth/width)*100;
	var h = (newHeight/height)*100;

	return {w: w, h: h};
};


export default EditorOutputCreator;
